import base from 'stores/search-base/mutations';
import * as types from './mutation-types';

export default {
  ...base,
  [types.ADD_TO_BASKET](state, asset) {
    state.basket.push(asset);
  },
  [types.SET_BASKET](state, assets) {
    state.basket = assets;
  },
  [types.REMOVE_FROM_BASKET](state, assets) {
    const idsToRemove = assets.map((a) => a.id);
    state.basket = state.basket.filter((a) => idsToRemove.indexOf(a.id) === -1);
  },
  [types.CLEAR_BASKET](state) {
    state.basket = [];
  },
  [types.SET_FAVORITES](state, favorites) {
    state.favorites = favorites;
  },
  [types.SAVE_FAVORITE](state, favorite) {
    const existingIndex = state.favorites.findIndex((s) => s.id === favorite.id);
    if (existingIndex !== -1) state.favorites.splice(existingIndex, 1);
    state.favorites.push(favorite);
  },
  [types.DELETE_FAVORITE](state, id) {
    const index = state.favorites.findIndex((s) => s.id === id);
    if (index > -1) state.favorites.splice(index, 1);
  },
  [types.REMOVE_RESULT](state, prd) {
    const index = state.results.hits.findIndex((hit) => hit.prd === prd);
    if (index > -1) {
      state.results.hits.splice(index, 1);
      state.results.total -= 1;
    }
  },
  [types.REPLACE_RESULT](state, result) {
    const index = state.results.hits.findIndex((hit) => hit.id === result.id);
    if (index > -1) state.results.hits[index] = result;
  },
  [types.SAVE_MSDS_SETTINGS](state, settings) {
    state.msdsSettings = settings;
  }
};
